import { put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { exportCouponSuccess, exportCouponFailure } from '../actions';
import { saveDownloadIds } from 'redux/direct-download/actions';
import CouponActionTypes from 'redux/coupon/types';
import { networkErrorHandler } from 'utils/errrorHandlers';
import { getOrgName } from 'utils/helpers';

const { API_BASE_URL } = urls || {};

function* exportCouponData({ payload }) {
  const { data, id, cb } = payload;
  const url = `${API_BASE_URL}/coupons/${id}/export`;

  const response = yield request({
    method: 'post',
    data,
    url,
  });

  if (response.success) {
    yield put(exportCouponSuccess());
    yield put(saveDownloadIds({id : response.raw.id, org: getOrgName()}));
    cb();
  } else {
    yield put(
      exportCouponFailure(
        'An error occured. Please reload the page to try again.'
      )
    );

    networkErrorHandler(response?.statusCode, response.message || 'An error occured. Please reload the page to try again.');
  }
}

export function* onExportCouponData() {
  yield takeLatest(
    CouponActionTypes.EXPORT_COUPON_START,
    exportCouponData
  );
}
